module.exports = __webpack_public_path__ + "assets/HKNova-SemiBold.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-SemiBold.woff2
// module id = 128
// module chunks = 0